import { ErrorComponent } from './error/error.component';
import { ProveedorModule } from './proveedor/proveedor.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CiudadanoModule } from './ciudadano/ciudadano.module';
import { EmpresaModule } from './empresa/empresa.module';
import { ExternalComponent } from './external.component';
import { ValidComponent } from './valid/valid.component';

const EXTERNAL_ROUTE: Routes = [
  {
    path: '',
    component: ExternalComponent,
    children: [
      {
        path: '',
        redirectTo: 'passarela',
        pathMatch: 'full'
      }
      ,
      {
        path: 'passarela',
        // component: ExternalComponent,
        loadChildren: () => CiudadanoModule
      }
      ,
      {
        path: 'empreses',
        // component: ExternalComponent,
        loadChildren: () => EmpresaModule
      }
      ,
      {
        path: 'proveidors',
        // component: ExternalComponent,
        loadChildren: () => ProveedorModule
      }
      ,
      {
        path: 'error',
        component: ErrorComponent,
        data: {
          authorities: [],
          pageTitle: 'PAGEERROR.title'
        }
      }
      ,
      {
        path: 'valid',
        component: ValidComponent,
        data: {
          authorities: [],
          pageTitle: 'VALID.title'
        }
      }
      ,
      {
        path: '**',
        // component: ExternalComponent,
        redirectTo: 'passarela'
      }
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(EXTERNAL_ROUTE)],
  exports: [RouterModule]
})
export class ExternalRoutingModule { }
